import React, { useEffect } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import PaginatedItems from "./pagination.component";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import { useNewsState } from "./context/news-context";
import { useNewsController } from "./context/news-controller";
import Skeleton from '@material-ui/lab/Skeleton';
import CustomBackdrop from "components/backdrop";


export function NewsPage() {
  const { news, newsPagedRequest, loading, categoriesNews } = useNewsState();
  const { onInit, handleOnChange, listNews } = useNewsController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();

  }, []);

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Notícias" },
        ]}
      />
      <PageTitle>Notícias</PageTitle>
      <Wrapper>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-term"
                  label="Título ou descrição"
                  value={newsPagedRequest?.term}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="select-category-id-labe">
                    Categoria
                  </InputLabel>
                  <Select
                    labelId="select-category-id-label"
                    id="select-category-id"
                    name="select-category-id"
                    value={newsPagedRequest?.categoryId}
                    onChange={(e) => handleOnChange(e)}
                    label="Categoria"
                  >
                    {categoriesNews?.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs="auto">
                <SearchButton onClick={() => (async () => {
                  await listNews(newsPagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <PaginatedItems currentItems={news} pageCount={news?.pageCount} />
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
